export default "__VITE_ASSET__338b5c52__"